import { useEffect } from "react";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, useMap, Marker, Popup } from "react-leaflet";

const berntsenCoordinates = [43.15328, -89.320656];

const smallIcon = new L.Icon({
   iconUrl: "/im.png",
   iconSize: [20, 37],
   iconAnchor: [10, 10],
   popupAnchor: [0, -10],
});

function ResizeMapOnShow({ visible }) {
   const map = useMap();
   useEffect(() => {
      if (visible) {
         const id = setTimeout(() => {
            map.invalidateSize();
         }, 250);
         return () => clearTimeout(id);
      }
   }, [visible, map]);
   return null;
}

function SetMapBounds({ transactions, selectedMarkerId }) {
   const map = useMap();
   useEffect(() => {
      const id = setTimeout(() => {
         var nonNullTrans = transactions?.results?.filter(t => t.latitude && t.longitude);
         if (nonNullTrans !== undefined && nonNullTrans.length > 0) {
            if (selectedMarkerId !== null) {
               const selectedTx = nonNullTrans.find(t => t.id === selectedMarkerId);
               if (selectedTx) {
                  map.setView([selectedTx.latitude, selectedTx.longitude], 19);
                  return;
               }
            }
            const bounds = L.latLngBounds(nonNullTrans.map(t => [t.latitude, t.longitude]));
            map.fitBounds(bounds);
         } else {
            map.setView(berntsenCoordinates, 16);
         }
      }, 250);
      return () => clearTimeout(id);
   }, [map, transactions, selectedMarkerId]);
   return null;
}

export default function TransactionMap({ transactions, showMap, selectedMarkerId }) {

   return (
      <MapContainer center={berntsenCoordinates} zoom={14} minZoom={2}>
         <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            maxZoom={19}
         />
         <ResizeMapOnShow visible={showMap} />
         <SetMapBounds transactions={transactions} selectedMarkerId={selectedMarkerId} />
         {
            transactions?.results?.filter(t => t.latitude && t.longitude).map(tx => (
               <Marker icon={smallIcon} key={tx.id} position={[tx.latitude, tx.longitude]}>
                  <Popup>Name: {tx.asset_name}  Owner: {tx.asset_owner}</Popup>
               </Marker>
            ))
         }
      </MapContainer>
   );
}